import React, { useEffect, useState } from 'react'
import { deleteTalentDocument, loadTalentDocuments } from '../../../utils/Network';
import { getDefaultName } from '../../../utils';
import TalentDocumentContent from '../../TalentDocumentContent';

export default function TalentDocumentsWidget({ talentId }) {
    const [loadingId, setLoadingId] = useState(0);
    const [documents, setDocuments] = useState([]);
    const [selectedDocumentId, setSelectedDocumentId] = useState(null);
    const [showDocumentDialog, setShowDocumentDialog] = useState(false);

    const reloadDocuments = () => {
        if (!talentId) return;
        loadTalentDocuments(talentId).then((items) => {
            setDocuments(items || []);
        });
    };

    useEffect(() => {
        setSelectedDocumentId(null);
        setShowDocumentDialog(false);
        reloadDocuments();
    }, [talentId]);

    const handleDelete = (documentId, e) => {
        e.preventDefault();
        setLoadingId(documentId);
        deleteTalentDocument(documentId).then(() => {
            setLoadingId(0);
            if (selectedDocumentId === documentId) {
                setSelectedDocumentId(null);
            }
            reloadDocuments();
        });
    };

    const openAddDialog = () => {
        setSelectedDocumentId(null);
        setShowDocumentDialog(true);
    };

    const openEditDialog = (documentId) => {
        setSelectedDocumentId(documentId);
        setShowDocumentDialog(true);
    };

    const closeDialog = () => {
        setShowDocumentDialog(false);
        setSelectedDocumentId(null);
    };

    const handleSaved = () => {
        closeDialog();
        reloadDocuments();
    };

    const handleSavedInline = () => {
        reloadDocuments();
    };

    const hasDocuments = documents.length > 0;
    const singleDocument = documents.length === 1 ? documents[0] : null;

    return (
        <div className="row">
            <div className="col-md-12">
                {!hasDocuments && (
                    <div className="d-flex justify-content-end mb-5">
                        <button type="button" className="btn btn-cm" onClick={openAddDialog}>
                            <i className="fa fa-plus"></i>
                        </button>
                    </div>
                )}
                {singleDocument ? (
                    <>
                        {/* <div className={`d-flex justify-content-end mb-2${loadingId === singleDocument.id ? ' loading' : ''}`}>
                            <button
                                type="button"
                                className="btn btn-default btn-sm cms-row-action-btn cms-row-action-btn-danger"
                                title="Delete"
                                onClick={(e) => {
                                    if (window.confirm('Are you sure you wish to delete this item?')) handleDelete(singleDocument.id, e);
                                }}
                            >
                                <i className="fa fa-trash"></i>
                            </button>
                        </div> */}
                        <TalentDocumentContent
                            key={`${talentId}-inline-${singleDocument.id}`}
                            talent_id={talentId}
                            document_id={singleDocument.id}
                            isModal={false}
                            embedInWidget={true}
                            onSaved={handleSavedInline}
                        />
                    </>
                ) : (
                    <div className="cms-dark-box no-border">
                        <div className="box-body no-padding">
                            <table className="table table-striped cms-list-table mb-0">
                                <tbody>
                                    {documents.map((item) => (
                                        <tr key={item.id} className={loadingId === item.id ? "loading" : ""}>
                                            <td className="kfont">{getDefaultName(item.names)}</td>
                                            <td className="text-right">
                                                <div className="btn-group cms-row-actions">
                                                    <button
                                                        type="button"
                                                        className="btn btn-default btn-sm cms-row-action-btn"
                                                        onClick={() => openEditDialog(item.id)}
                                                    >
                                                        <i className="fa fa-edit"></i>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-default btn-sm cms-row-action-btn cms-row-action-btn-danger"
                                                        onClick={(e) => { if (window.confirm('Are you sure you wish to delete this item?')) handleDelete(item.id, e) }}
                                                    >
                                                        <i className="fa fa-trash"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>

            {showDocumentDialog && (
                <div className="modal fade in" style={{ display: 'block', background: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            
                            <div className="modal-body mb-0">
                                <TalentDocumentContent
                                    key={`${talentId}-${selectedDocumentId || 'new'}`}
                                    talent_id={talentId}
                                    document_id={selectedDocumentId}
                                    isModal={true}
                                    onClose={closeDialog}
                                    onSaved={handleSaved}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
